import { useEffect, useState } from "react";
import { ContainerScreenGeneral, MuniSpinner2, Table } from "../../components";
import { useActasStore } from "../../store/actasStore";
import { useGeneralAppStore } from "../../store/generalAppStore";
import { useActaDetalleStore } from "../../store/actaDetalleStore";
import { tableData } from "./tableData";
import RangoFecha from "../../components/RangoFecha";
import { filtrarActas, orderActas } from "./handler";
import { filterRangoFecha } from "../../utils/filterRangoFechas";
import { useActas } from "../../hooks/useActas";
import ModalsOpcionesActas from "../../views/modals";
import useNotificadores from "../../api/notificadores";
import FilterBar from "./components/FilterBar";
import { useNotificadoresStore } from "../../store/notificadoresStore";
import HeaderNotificador from "./components/HeaderNotificador";
import Table2 from "../../components/Table2";
import NotificadoresBar from "./components/NotificadoresBar/NotificadoresBar";
import { reporteNotificadoresHandler } from "../../handlers/notificadores.handler";
import ModalFiltroFechas from "../../views/modals/ModalFiltroFechas";
import { format } from 'date-fns'
import NotificadoresBar2 from "./components/NotificadoresBar/NotificadoresBar2";

const ReportesNotificadores = () => {

    //TODO ESTADOS GLOBALES
    const { loads, handlerModal, modals } = useGeneralAppStore();
    const { actas, actasFilter, setActasFilter, cleanActas, codigosZonales } = useActasStore();
    // const { notificadores, notificadorSelect, filterReporteNotificadores, reporteNotificador, fechasReporte } = useNotificadoresStore();
    const { notificadores, notificadorSelect, filterReporteNotificadores, reporteNotificador, fechasReporte, filterEstado, submitFilter,setFilterEstado } = useNotificadoresStore();
    const { cleanStore, coleccionActasDetalle, setAllActaDetalle } = useActaDetalleStore();


    //^ ESTADOS LOCALES
    const [order, setOrder] = useState("des");
    const [orderField, setOrderField] = useState("numero_acta");
    const [filtersField, setFiltersField] = useState({
        fecha_hora: "",
    })

    const fechaHoy = new Date();
    const fechaUnMesAntes = new Date(fechaHoy);
    fechaUnMesAntes.setMonth(fechaUnMesAntes.getMonth() - 1);
    const fechaHaceUnMes = fechaUnMesAntes;

    const [filtros, setFiltros] = useState({
        fecha_desde: fechaHaceUnMes,
        fecha_hasta: fechaHoy,
    });
    // const [filtros, setFiltros] = useState({
    //     fecha_desde: fechaHaceUnMes,
    //     fecha_hasta: fechaHoy,
    // });

    //~ HOOKS
    const { getActas, getActaDetalle } = useActas()
    const { getNotificadores } = useNotificadores()

    const loadKeys = [
        "asignar_notificador",
        "acta_detalle",
        "desasignar_notificador",
        "marcar_impresa",
        "actas",
        "notificadores"
    ];

    useEffect(() => {
        // getActas('reportes_notificadores')
        // getNotificadores()
        setFilterEstado('todas')
        return () => {
            cleanStore();
            cleanActas();
        }
    }, [])

    /* useEffect(() => {

        if (notificadorSelect && fechasReporte) {
            reporteNotificadoresHandler({
                user_id: notificadorSelect?.usuarioID,
                fecha_desde: format(fechasReporte?.fecha_desde, 'yyyy-MM-dd'),
                fecha_hasta: format(fechasReporte?.fecha_hasta, 'yyyy-MM-dd'),
            })
            // console.log('entre')
        }

    }, [notificadorSelect, fechasReporte]) */

    useEffect(() => {

        if (notificadorSelect && fechasReporte && filterEstado && submitFilter) {
            reporteNotificadoresHandler({
                user_id: notificadorSelect?.usuarioID,
                fecha_desde: format(fechasReporte?.fecha_desde, 'yyyy-MM-dd'),
                fecha_hasta: format(fechasReporte?.fecha_hasta, 'yyyy-MM-dd'),
                estado_id: filterEstado
            })
            // console.log('entre')
        }

    }, [submitFilter])

    // console.log(reporteNotificador)

    //* VEEEER
    // useEffect(() => {

    //     if (filterReporteNotificadores) {
    //         reporteNotificadoresHandler(filterReporteNotificadores);
    //     }

    // }, [filterReporteNotificadores])


    // useEffect(() => {
    //     if (actas) {
    //         const actasFiltradas = filtrarActas(null, actas, filtersField, order, orderField, codigosZonales);
    //         setActasFilter(actasFiltradas)
    //     }
    // }, [filtersField, order, orderField, filtros])

    // console.log(filtersField)
    return (
        <ContainerScreenGeneral titulo={'Reporte de notificadores'} linkBack={'/'} size={'lg'}>
            <div className="position-relative">

                {/* <NotificadoresBar setFiltersField={setFiltersField} setFiltros={setFiltros} filtros={filtros} /> */}
                <NotificadoresBar2 setFiltersField={setFiltersField} setFiltros={setFiltros} filtros={filtros} />
                {/* <FilterBar excel={"front"} estado_id={null} filtros={filtros} setFiltros={setFiltros} setFiltersField={setFiltersField} filtersField={filtersField} loading={loadKeys.some(key => loads.includes(key))} /> */}



                {/* <HeaderNotificador filtersField={filtersField} setFiltersField={setFiltersField} estados={[]} actas={actas} actasFilter={actasFilter} /> */}
                {/* <Table2
                    height={"500px"}
                    loading={loads.some(load =>
                        ["asignar_notificador", "acta_detalle", "desasignar_notificador", "marcar_impresa", "actas_a_imprimir", "actas", "notificadores", "reporte_notificadores"].includes(load)
                    )}
                    data={tableData(
                        reporteNotificador,
                        setFiltersField,
                        setOrder,
                        setOrderField,
                        coleccionActasDetalle,
                        setAllActaDetalle,
                        handlerModal,
                        getActaDetalle
                    )}
                    getRowClassName={({ row }) => {
                        if (row?.estado_id == 4 || row?.estado_id == 11 || row?.estado_id == 13) {
                            return 'notificado';
                        } else if (row.estado_id == 9) {
                            return 'motivo';
                        } else {
                            return "reporte";
                        }
                    }}

                    sx={{

                        ".MuiDataGrid-row.notificado": {
                            backgroundColor: '#28A745',
                            color: "white"
                        },
                        ".MuiDataGrid-row.motivo": {
                            backgroundColor: '#DC3545',
                            color: "white"
                        },
                        ".MuiDataGrid-row.reporte": {
                            backgroundColor: 'white',
                            color: "black"
                        },
                        ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.reporte": {
                            backgroundColor: '#D6D6D6',
                            color: "black"
                        },
                        ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.notificado": {
                            backgroundColor: '#1f8136',
                            color: "white"
                        },
                        ".MuiDataGrid-row.Mui-hovered.MuiDataGrid-row.motivo": {
                            backgroundColor: '#b62c3a',
                            color: "white"
                        },
                    }}
                /> */}
            </div>
            <ModalsOpcionesActas />


        </ContainerScreenGeneral>
    );
}
export default ReportesNotificadores;